import styled, { css } from 'styled-components'

export const Wrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    width: 100%;
    max-height: 25rem;
    bottom: 0.1rem;
    left: 0;
    overflow: auto;
    padding: 0;
    z-index: 99999;

    &::-webkit-scrollbar {
      width: 0;
    }
  `
)
